import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tooltipIcon",
  "use": "tooltipIcon-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"tooltipIcon\"><path d=\"M8 1C4.14 1 1 4.14 1 8s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7zm0 1.05A5.942 5.942 0 0 1 13.95 8 5.942 5.942 0 0 1 8 13.95 5.942 5.942 0 0 1 2.05 8 5.942 5.942 0 0 1 8 2.05zM8 4.5a.7.7 0 1 0 0 1.4.7.7 0 0 0 0-1.4zm-.008 2.442a.525.525 0 0 0-.517.533v3.85a.525.525 0 1 0 1.05 0v-3.85a.525.525 0 0 0-.533-.533z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol